import { createFileRoute } from "@tanstack/react-router";
import { trpc } from "@/app/api/trpcClient";
import { Card, CardContent, CardHeader, CardTitle } from "@/app/components/ui/card";

function Version() {
  const { data: version, isLoading, error } = trpc.version.get.useQuery();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>Team Dash System Version</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-2 text-sm">
            <p>
              <strong>Service:</strong> team-dash
            </p>
            <p>
              <strong>Environment:</strong> {import.meta.env.MODE}
            </p>
            {isLoading && <p>Loading version info...</p>}
            {error && <p className="text-red-500">Error loading version: {error.message}</p>}
            {version && (
              <>
                <p>
                  <strong>Version:</strong> {version.version}
                </p>
                <p>
                  <strong>Branch:</strong> {version.branch}
                </p>
                <p>
                  <strong>Commit:</strong> {version.commitRef}
                </p>
                <p>
                  <strong>Built:</strong> {new Date(version.timestamp).toLocaleString()}
                </p>
              </>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export const Route = createFileRoute("/version")({
  component: Version,
});
